import { render, staticRenderFns } from "./RSQViolenceForm2.vue?vue&type=template&id=0e80e2a6&"
import script from "./RSQViolenceForm2.vue?vue&type=script&lang=js&"
export * from "./RSQViolenceForm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports